<template>
  <popup-modal ref="popup">
    <div class="d-flex">
      <div class="statusBar"
           :class="{'bg-success':type==='success','bg-info':type==='information','bg-error':type==='error'}">
      </div>
      <div
          class="w-100 d-flex flex-xs-column justify-content-between align-items-xs-start align-items-center pl-3 pr-4 py-3 my-md-3">
        <div class="statusIcon"
             :class="{'bg-success':type==='success','bg-info':type==='information','bg-error':type==='error'}">
          <span>
            <i v-if="type!=='success'" class="fa fa-exclamation"></i>
            <i v-else class="fa fa-check"></i>
          </span>
        </div>
        <div class="content">
          <div class="content-title">{{ title }}</div>
          <p>{{ message }}</p>
        </div>
        <div class="closeIcon"><span @click="_cancel"><i class="fa fa-times"></i></span></div>
      </div>
    </div>
  </popup-modal>
</template>

<script>
// import PopupModal from "./PopupModal";

export default {
  name: 'alertBox',
  components: {
    PopupModal: () => import(/*webpackChunkName: "PopupModal"*/ './PopupModal')
  },
  data() {
    return {
      // Parameters that change depending on the type of dialogue
      type: undefined,
      title: undefined,
      message: undefined, // Main text content
      okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
      cancelButton: 'CANCEL', // text for cancel button

      // Private variables
      resolvePromise: undefined,
      rejectPromise: undefined,
    }
  },

  methods: {
    show(opts = {}) {
      this.type = opts.type
      this.message = opts.message
      // if (opts.type === 'success') {
      //   this.title = 'Yay! Everything worked!';
      // } else if (opts.type === 'error') {
      //   this.title = 'Uh oh! Something went wrong';
      // } else if (opts.type === 'information') {
      //   this.title = 'Do you know?'
      // }
      if (opts.title) {
        this.title = opts.title
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    _cancel() {
      this.$refs.popup.close();
      this.type = undefined;
      this.title = undefined;
      this.message = undefined;
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .window {
  padding: 0;
}

.statusBar {
  width: 14px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.statusIcon {
  width: 42px;
  height: 42px;
  text-align: center;
  color: #FFFFFF;
  border-radius: 25rem;
  padding: 0.75rem;
}

.bg-success {
  background-color: #33c333;
}

.bg-error {
  background-color: #ffb500;
}

.bg-info {
  background-color: #6767e7;
}

.content {
  padding-left: 12px;

  div, p {
    color: rgba(88, 88, 88, 0.87);
  }

  div.content-title {
    font-size: 21px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 14px;
  }
}

.closeIcon {
  span {
    font-size: 20px;
    color: #8c8c8c;
    cursor: pointer;
  }
}

@media only screen and (max-width: 540px) {
  .align-items-xs-start {
    align-items: start !important;
  }
  .content {
    padding-left: 0;
    margin-top: 0.75rem;
  }
  div.closeIcon {
    position: absolute;
    top: 3.5px;
    right: 15px;
  }
}

@media only screen and (min-width: 1080px) {
  /deep/ .window {
    width: 530px;
    padding: 0 !important;
  }
}
</style>
